module.exports = __webpack_public_path__ + "media/images/shared/icon-beltRecords-75294d5721a58d2b14fe210b89a81a3b.png";